import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfAlert,
  CcfApprovedIcon,
  CcfAttachmentDownloadIcon,
  CcfAttachmentPreviewIcon,
  CcfBox,
  CcfButton,
  CcfDoubleArrowIcon,
  CcfEmailJpgIcon,
  CcfEmailPdfIcon,
  CcfEmailReplyIcon,
  CcfPendingApprovalIcon,
  CcfSnackBar,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import React, { useEffect, useState } from 'react';
import styles from './ccf-digital-contact-body.module.scss';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import {
  activeContactSelector,
  getIsCopilotEmailResponseGenerated,
  selectEmailWithApprovalState,
  setIsCopilotEmailResponseGenerated,
  updateEmailWithApproval,
} from '../../ccf-inbox/ccf-inbox.slice';
import { useDispatch, useSelector } from 'react-redux';
import CcfLiveDigitalEmailTemplate from '../../ccf-digital-email-template/ccf-live-digital-email-template';
import {
  getEmailHistoryDetails,
  interactionSliceActions,
} from '../ccf-interaction-space.slice';
import { fetchEmailTopics } from '../../ccf-app-space/ccf-copilot/ccf-copilot-api';

import CcfInteractionBodyAccordionStyles from './ccf-interaction-body-accordion.styles';
import { useTheme, Modal, Box } from '@mui/material';
import { useMsal } from '@azure/msal-react';

/* eslint-disable-next-line */
export interface CcfLiveDigitalEmailCardProps {
  i: any;
  replyCard?: any;
  emailListLength: number;
  emailDateData: any;
  emailSentDate: any;
  subject: string;
}
/**
 * Component to display EMAIL interaction
 * @example <CcfDigitalMessageCard />
 * @returns twitter card
 */
export function CcfLiveDigitalEmailCard(props: CcfLiveDigitalEmailCardProps) {
  const [hoverIcon, setHoverIcon] = React.useState<boolean[]>([]);
  const history = useHistory();
  const [translate] = useTranslator();
  const activeContact = useSelector(activeContactSelector);
  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const loginCredentialsFirstName =
    loginCredentialsArray[0].charAt(0).toUpperCase() +
    loginCredentialsArray[0].slice(1).toLowerCase();
  const [sentForApproval, setSentForApproval] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const [newEmailBox, setNewEmailBox] = useState(false);
  const { setPreviewImgPathData } = interactionSliceActions;
  const dispatch = useDispatch();
  const emailWithApprovalState = useSelector(selectEmailWithApprovalState);
  const emailDateData = useSelector(getEmailHistoryDetails);
  const theme = useTheme();
  const simStyles = CcfInteractionBodyAccordionStyles(theme);
  const isCopilotEmailResponseGenerated = useSelector(
    getIsCopilotEmailResponseGenerated
  );
  const userReplyChatData = activeContact?.customerChatReplyJsonData ?? [];
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState('');

  /**
   * Function to open email reply click
   * @example - openEmailReplyHandler()
   */
  const openEmailReplyHandler = async () => {
    setNewEmailBox(true);
    if (!props?.replyCard?.isAgentReply) {
      await fetchEmailTopics(
        activeContact?.id,
        userReplyChatData[0]?.messageFrom,
        dispatch
      );
    }
  };

  /**
   * Function to close email reply
   * @example - closeEmailReplyHandler()
   */
  const closeEmailReplyHandler = () => {
    setNewEmailBox(false);
    isCopilotEmailResponseGenerated &&
      dispatch(setIsCopilotEmailResponseGenerated(false));
  };

  /**
   * Used to close the snackbar
   * @param event -React.SyntheticEvent
   * @param reason -string
   * @example - handleClose()
   */
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowToast(false);
  };

  // useEffect(() => {
  //   if (isCopilotEmailResponseGenerated) {
  //     openEmailReplyHandler();
  //   }
  // }, [isCopilotEmailResponseGenerated]);

  useEffect(() => {
    setTimeout(() => {
      setShowToast(true);
      setSentForApproval(true);
    }, 5000);
    setTimeout(() => {
      setSentForApproval(false);
      dispatch(updateEmailWithApproval(false));
    }, 10000);
  }, []);

  /**
   * Funtrion to download attchment from email
   * @param e -
   * @example - download('broken-luggage.png')
   */
  function download(attachment: any) {
    const downloadLink = attachment.downloadLink;
    axios({
      url: downloadLink,
      method: 'GET',
      responseType: 'blob',
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachment.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  /**
   *Function to open attchment in preview mode
   * @param fileUrl -any
   * @example - openPreviewImages(fileUrl)
   */
  const openPreviewImages = (fileUrl: string) => {
    setPreviewFileUrl(fileUrl);
    setPreviewOpen(true);
  };

  /**
   *Function to close preview mode
   * @example - closePreview()
   */
  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewFileUrl('');
  };

  useEffect(() => {
    /**
     *Function to handle keyboard event
     * @example - handleKeyDown()
     */
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closePreview();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  /**
   * function  to handle hover icon functionality for preview aand download
   * @param param0 - param
   * @example showHoverIcon()
   * @returns
   */
  const showHoverIcon = (i: any) => {
    const newHoverIcon = Array(props?.replyCard?.attachments?.length).fill(
      false
    );
    newHoverIcon[i] = true;
    setHoverIcon(newHoverIcon);
  };

  /**
   * function  to handle hover icon functionality for preview aand download
   * @param param0 - param
   * @example hideHoverIcon()
   * @returns
   */
  function hideHoverIcon() {
    setHoverIcon(Array(props?.replyCard?.attachments?.length).fill(false));
  }

  // /**
  //  *
  //  * @returns -
  //  * @example
  //  */
  // function returnPreviousDate() {
  //   const date = new Date();

  //   date.setDate(date.getDate() - (props.index + 1 || 0));

  //   return date.toLocaleString('en-us', {
  //     month: 'short',
  //     day: '2-digit',
  //     year: 'numeric',
  //   });
  // }

  /**
   * function  to render Icon For Attachments
   * @param param0 - param
   * @example renderIconForAttachments()
   * @returns
   */
  function renderIconForAttachments(attachment: any) {
    switch (attachment.fileType) {
      case 'image':
        return <CcfEmailJpgIcon />;
      case 'pdf':
        return <CcfEmailPdfIcon />;
      default:
        return '';
    }
  }

  /**
   * function  to render images in preview
   * @param param0 - param
   * @example renderImagesInPreview()
   * @returns
   */
  function renderImagesInPreview(attachment: any) {
    switch (attachment.fileType) {
      case 'image':
        return <CcfEmailJpgIcon style={{ height: '60px', width: '60px' }} />;
      case 'pdf':
        return <CcfEmailPdfIcon style={{ height: '60px', width: '60px' }} />;
      default:
        return '';
    }
  }
  return (
    <>
      {Object.keys(props?.replyCard).length > 0 && (
        <CcfBox
          className={styles.emailCardMainContainer}
          style={{
            marginLeft:
              props?.replyCard?.authorUser.firstName === 'Agent' ? '5%' : '2%',
          }}
        >
          <CcfTypography
            className={
              props?.replyCard?.isAgentReply
                ? styles.agentName
                : styles.customerName
            }
          >
            {`${props?.replyCard?.authorUser.firstName} ${props?.replyCard?.authorUser.surname}`}
          </CcfTypography>
          <CcfBox
            className={styles.originalEmailCard}
            style={{
              background:
                props?.replyCard?.authorUser.firstName !== 'Agent'
                  ? '#FFFFFF'
                  : '#F1F1F1',
            }}
          >
            {emailAccordionHeader(
              translate,
              props?.replyCard,
              activeContact,
              props?.emailSentDate,
              simStyles,
              props?.subject,
              loginCredentialsFirstName
            )}
            <div style={{ padding: '10px' }}>
              <div
                contentEditable={false}
                className={styles.orignalEmailText}
                dangerouslySetInnerHTML={{
                  __html:
                    props?.replyCard?.messageContent?.payload?.text?.replace(
                      'Liam Davis',
                      activeContact?.customer?.firstName +
                        ' ' +
                        activeContact?.customer?.lastName
                    ) || '',
                }}
              ></div>
              {props?.replyCard &&
                props?.replyCard?.attachments?.length > 0 && (
                  <CcfBox style={{ display: 'flex', marginTop: '5%' }}>
                    {props?.replyCard?.attachments.map(
                      (attachment: any, index: any) => (
                        <CcfBox
                          key={index}
                          style={{ height: '150px', width: '150px' }}
                          className={styles.originalEmailAttchmentBlock}
                        >
                          <div
                            style={{ height: '30%' }}
                            className={styles.originalEmailAttchmentFirstBlock}
                          >
                            {renderIconForAttachments(attachment)}
                            <div className={styles.attchmentFileAndSizeGroup}>
                              <CcfTypography className={styles.attchedFileName}>
                                {attachment.fileName}
                              </CcfTypography>
                              <CcfTypography className={styles.attchedFileSize}>
                                372 KB
                              </CcfTypography>
                            </div>
                          </div>
                          <div
                            style={{ height: '70%' }}
                            className={styles.originalEmailAttchmentSecondBlock}
                            id={'attachment' + index}
                            onMouseEnter={() => showHoverIcon(index)}
                            onMouseLeave={hideHoverIcon}
                          >
                            {renderImagesInPreview(attachment)}
                            {hoverIcon[index] === true && (
                              <div className={styles.hoverBackground}>
                                <div
                                  className={styles.hoverPreviewBlock}
                                  onClick={() =>
                                    openPreviewImages(attachment.fileUrl)
                                  }
                                >
                                  <CcfAttachmentPreviewIcon />
                                  <CcfTypography
                                    className={styles.hoverIconText}
                                    translationKey={'preview'}
                                  />
                                </div>
                                <div
                                  className={styles.hoverDownloadBlock}
                                  onClick={() => download(attachment)}
                                >
                                  <CcfAttachmentDownloadIcon />
                                  <CcfTypography
                                    className={styles.hoverIconText}
                                    translationKey={'download'}
                                  />
                                </div>
                              </div>
                            )}
                            <Modal open={previewOpen} onClose={closePreview}>
                              <Box
                                className={styles.modalContent}
                                onClick={closePreview}
                              >
                                <img
                                  src={previewFileUrl}
                                  alt="Preview"
                                  className={styles.previewImage}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </Box>
                            </Modal>
                          </div>
                        </CcfBox>
                      )
                    )}
                  </CcfBox>
                )}
              {props?.i === props?.emailListLength - 1 && (
                <CcfBox
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <CcfButton
                    primary
                    variant="contained"
                    color="primary"
                    startIcon={<CcfEmailReplyIcon />}
                    onClick={openEmailReplyHandler}
                    id="agent_email_replyButton"
                  >
                    {translate('reply')}
                  </CcfButton>
                </CcfBox>
              )}
            </div>
            {emailWithApprovalState &&
              activeContact?.customer.replywithApproval === 'Yes' &&
              props?.i === props?.emailListLength - 1 && (
                <CcfBox
                  className={
                    sentForApproval
                      ? styles.approvalApprovedNotification
                      : styles.approvalPendingNotification
                  }
                >
                  {sentForApproval ? (
                    <CcfApprovedIcon
                      style={{
                        width: '16px',
                        height: '16px',
                      }}
                    />
                  ) : (
                    <CcfPendingApprovalIcon
                      style={{
                        marginLeft: '10px',
                        fill: 'transparent',
                        width: '16px',
                        height: '16px',
                      }}
                    />
                  )}
                  <div className={styles.approvalTextAndTimerBlock}>
                    <CcfTypography className={styles.txtApprovals}>
                      {sentForApproval
                        ? 'Message Approved & Sent'
                        : 'Pending Approval'}
                    </CcfTypography>
                    <CcfTypography className={styles.txtApprovalTimer}>
                      5 minutes ago
                    </CcfTypography>
                  </div>
                </CcfBox>
              )}
            <CcfBox>
              {emailWithApprovalState &&
                activeContact?.customer.replywithApproval === 'Yes' &&
                props?.i === props?.emailListLength - 1 && (
                  <CcfSnackBar
                    onClose={() => handleClose()}
                    open={showToast}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  >
                    <div>
                      <CcfAlert closeAlert={handleClose} severity="success">
                        Your email was approved & sent
                      </CcfAlert>
                    </div>
                  </CcfSnackBar>
                )}
            </CcfBox>
          </CcfBox>
        </CcfBox>
      )}
      {(newEmailBox || Object.keys(props?.replyCard).length === 0) &&
        !isCopilotEmailResponseGenerated && (
          <CcfLiveDigitalEmailTemplate
            closeEmailReplyHandler={closeEmailReplyHandler}
          />
        )}
      {isCopilotEmailResponseGenerated && (
        <CcfLiveDigitalEmailTemplate
          closeEmailReplyHandler={closeEmailReplyHandler}
        />
      )}
    </>
  );
}

/**
 *Function to display email accordion header
 * @param replyCard - any
 * @param activeContact - any
 * @example renderdaysDiff()
 */
function renderdaysDiff(dateTwo: any) {
  const date1: any = new Date();
  const date2: any = new Date(dateTwo.toString());

  const diffTime = Math.abs(date1 - date2);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays === 1) {
    const copydate1 = date1.toLocaleString('en-us', {
      weekday: 'short',
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
    return `${copydate1} (Today)`;
  } else if (diffDays === 2) {
    return `${dateTwo} (${diffDays - 1} day ago)`;
  } else {
    return `${dateTwo} (${diffDays - 1} days ago)`;
  }
}

/**
 *Function to display email accordion header
 * @param replyCard - any
 * @param activeContact - any
 * @example emailAccordionHeader()
 */
export function emailAccordionHeader(
  translate: any,
  replyCard: any,
  activeContact: any,
  emailSentDate: any,
  simStyles: any,
  subject: string,
  loginCredentialsFirstName?: string
) {
  return (
    <CcfAccordion sx={simStyles.accordionContainer}>
      <CcfAccordionSummary
        sx={simStyles.accordionHeader}
        expandIcon={<CcfDoubleArrowIcon sx={simStyles.expandedIcon} />}
      >
        <div
          className={styles.padding5px}
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <CcfTypography className={styles.accordionEmailText}>
            {`${translate('from')}: ${replyCard?.authorUser.loginUsername}`}
          </CcfTypography>
          <CcfTypography className={styles.accordionEmailDateAndTImeText}>
            {renderdaysDiff(emailSentDate)}
          </CcfTypography>
        </div>
      </CcfAccordionSummary>
      <CcfAccordionDetails sx={simStyles.setAccordionDetailsItem}>
        <div
          className={styles.padding5px}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <CcfTypography className={styles.accordionEmailText}>
            {`${translate('to')}: ${replyCard?.authorUser.emailAddress}`}
          </CcfTypography>
          <CcfTypography className={styles.accordionEmailText}>
            {`${translate('subject')}: ${subject}`}
          </CcfTypography>
        </div>
      </CcfAccordionDetails>
    </CcfAccordion>
  );
}

export default CcfLiveDigitalEmailCard;
